import {Component, Input} from '@angular/core';
import {EventItem, League, Lookups} from "@model";
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AbstractComponent, OrganiserContactModalComponent,} from "@components";
import {environment} from "@environment";

@Component({
  selector: 'app-contacts-tab',
  templateUrl: './contacts-tab.component.html',
  styleUrls: ['./contacts-tab.component.scss']
})
export class ContactsTabComponent extends AbstractComponent {
  @Input() currentItem: EventItem | League | undefined;
  @Input({required: true}) languages: Lookups[] = [];

  isEventItem(item: any): item is EventItem {
    return item && 'phoneNumbers' in item;
  }

  constructor(private modalService: NgbModal) {
    super();
  }

  openContactOrganiserModal() {
    const modalRef =  this.modalService.open(OrganiserContactModalComponent, {
      centered: true,
      windowClass: 'contacts-modal',
    });
    modalRef.componentInstance.currentItem = this.currentItem;
  }

  protected readonly environment = environment;
}
